"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var dealer = {
    DEALER_DETAILS: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment DealerDetails on Dealer {\n      externalId\n      label\n      postCode\n      address {\n        address\n        city\n        phone\n      }\n    }\n  "], ["\n    fragment DealerDetails on Dealer {\n      externalId\n      label\n      postCode\n      address {\n        address\n        city\n        phone\n      }\n    }\n  "]))),
};
exports.default = dealer;
var templateObject_1;
